<app-header (toggleMenuEvent)="toggleMenu($event)"></app-header>
<mat-sidenav-container class="layout-container">
  <mat-sidenav #sidenav mode="side" [opened]="isSideMenuOpen" class="layout-sidenav">
    <app-left-menu></app-left-menu>
  </mat-sidenav>
  <mat-sidenav-content class="layout-sidenav-content" [class.isLoading]="menuNavigationService.isLoading">
    <mat-spinner *ngIf="menuNavigationService.isLoading" [diameter]="80"></mat-spinner>
    <iframe title="iframePortal" id="iframePortal" src=""></iframe>
  </mat-sidenav-content>
</mat-sidenav-container>